var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlLegs2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1258,
    viewBox: "21 0 1140 1245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Legs / 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.17 1047.59C156 1016.41 151.55 989.489 151.55 989.489L183.957 890.109L86.0002 979.124L150.123 1136.9C150.123 1136.9 156.42 1092.72 156.17 1047.59ZM844.159 1098.46C797.237 1079.48 707.111 1113.49 707.111 1113.49L668.541 1127.95L685.67 1188.66L844.159 1098.46Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    d: "M530.605 313.839L533.706 327.932L671.398 951.733L707.11 1113.49L668.548 1127.95C668.548 1127.95 644.333 1063.76 609.609 970.54C567.189 856.714 509.123 699.596 460.343 563.261C457.513 555.33 454.721 547.499 451.948 539.725C447.838 549.089 443.573 558.53 439.153 568.01C419.688 609.907 397.314 652.793 371.626 695.834C326.859 770.866 281.007 834.514 242.833 883.178C189.788 950.802 151.555 989.481 151.555 989.481L128.193 941.808C128.193 941.808 161.617 910.844 205.434 843.57C263.287 754.734 339.248 602.637 380.272 374.986C382.017 365.37 383.685 355.599 385.294 345.713C383.897 341.327 382.559 337.103 381.299 333.07C381.319 333.07 381.299 333.051 381.299 333.051C372.904 306.197 367.67 287.063 366.603 278.24C356.871 198.209 399.272 119.667 399.272 119.667L407.919 116.664C408.075 113.137 408.191 109.567 408.307 106H570.195C568.411 118.137 563.177 171.259 546.193 249.103C541.811 269.131 536.673 290.804 530.605 313.837L530.605 313.839Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants",
    d: "M548.248 260.561C555.751 302.34 564.824 352.767 575.662 413.063C625.973 693.003 682.14 948.476 682.14 948.476L671.399 951.735L609.61 970.539L585.608 977.831C585.608 977.831 511.838 785.308 447.683 593.602C445.395 598.914 443.05 604.209 440.684 609.5C356.697 796.65 261.619 903.089 261.619 903.089L242.832 883.178L205.433 843.57L197.93 835.619C197.93 835.619 311.891 681.857 376.201 359.592C365.266 317.384 357.782 281.537 355.417 256.003C348.922 185.509 393.01 121.956 405.089 106L572.967 106C570.757 118.875 564.553 177.909 548.248 260.561L548.248 260.561Z",
    fill: "#19141E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Overlay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    opacity: 0.145368,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M682.14 948.476L671.399 951.735L609.61 970.539L585.608 977.831C585.608 977.831 511.837 785.308 447.683 593.602C444.814 585.073 441.964 576.541 439.153 568.01C416.547 499.494 395.627 432.18 380.272 374.986C378.857 369.77 377.519 364.633 376.201 359.592C365.266 317.385 357.782 281.537 355.417 256.003C348.922 185.509 393.01 121.956 405.088 106H520.446C524.653 129.401 532.776 174.538 546.193 249.103C546.852 252.843 547.55 256.662 548.248 260.561C555.751 302.34 564.824 352.767 575.662 413.063C625.973 693.003 682.14 948.476 682.14 948.476Z",
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlLegs2);
export default __webpack_public_path__ + "static/media/Girl-Legs-2.a912d530.svg";
export { ForwardRef as ReactComponent };